// src/App.js

import React, { useCallback, useEffect, useMemo, useState, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import api from './api/api';
import jwtDecode from 'jwt-decode';
import {
  CssBaseline,
  Snackbar,
  Alert,
  CircularProgress,
  Box,
  Typography,
  Stack,
  Chip,
} from '@mui/material';

import LoginForm from './pages/components/LoginForm';
import Layout from './pages/components/Layout';

/* ────────────────────────────── PÁGINAS ────────────────────────────── */

// Inicio / Apps / POS
const Inicio = lazy(() => import('./pages/Inicio'));
const POS_Administrativo = lazy(() => import('./pages/POS_Administrativo'));
const ImbraSyncPage = lazy(() => import('./pages/ImbraSyncPage'));
const INTEGRANUBE_PortalApps = lazy(() => import('./pages/INTEGRANUBE_PortalApps'));
const APP_InventarioRapido = lazy(() => import('./pages/APP_InventarioRapido'));

// CRM
const CRM_Dashboard = lazy(() => import('./pages/CRM_Dashboard'));
//const CRM_Contactos = lazy(() => import('./pages/CRM_Contactos'));
//const CRM_ContactosDetalle = lazy(() => import('./pages/CRM_ContactosDetalle'));
//const CRM_ContactosCrear = lazy(() => import('./pages/CRM_ContactosCrear'));
//const CRM_ContactosEditar = lazy(() => import('./pages/CRM_ContactosEditar'));
//const CRM_ContactosCargaMasiva = lazy(() => import('./pages/CRM_ContactosCargaMasiva'));
//const CRM_Empresas = lazy(() => import('./pages/CRM_Empresas'));
//const CRM_EmpresasDetalle = lazy(() => import('./pages/CRM_EmpresasDetalle'));
//const CRM_EmpresasCrear = lazy(() => import('./pages/CRM_EmpresasCrear'));
//const CRM_EmpresasEditar = lazy(() => import('./pages/CRM_EmpresasEditar'));
//const CRM_EmpresasCargaMasiva = lazy(() => import('./pages/CRM_EmpresasCargaMasiva'));
//const CRM_Oportunidades = lazy(() => import('./pages/CRM_Oportunidades'));
//const CRM_OportunidadesDetalle = lazy(() => import('./pages/CRM_OportunidadesDetalle'));
//const CRM_OportunidadesCrear = lazy(() => import('./pages/CRM_OportunidadesCrear'));
//const CRM_OportunidadesEditar = lazy(() => import('./pages/CRM_OportunidadesEditar'));
const CRM_Casos = lazy(() => import('./pages/CRM_Casos'));
const CRM_CasosDetalle = lazy(() => import('./pages/CRM_CasosDetalle'));
const CRM_CasosCrear = lazy(() => import('./pages/CRM_CasosCrear'));
//const CRM_CasosEditar = lazy(() => import('./pages/CRM_CasosEditar'));
//const CRM_Actividades = lazy(() => import('./pages/CRM_Actividades'));
//const CRM_ActividadesDetalle = lazy(() => import('./pages/CRM_ActividadesDetalle'));
//const CRM_ActividadesCrear = lazy(() => import('./pages/CRM_ActividadesCrear'));
//const CRM_ActividadesEditar = lazy(() => import('./pages/CRM_ActividadesEditar'));
//const CRM_Campanas = lazy(() => import('./pages/CRM_Campanas'));
//const CRM_CampanasDetalle = lazy(() => import('./pages/CRM_CampanasDetalle'));
//const CRM_CampanasCrear = lazy(() => import('./pages/CRM_CampanasCrear'));
//const CRM_CampanasEditar = lazy(() => import('./pages/CRM_CampanasEditar'));
//const CRM_Seguimientos = lazy(() => import('./pages/CRM_Seguimientos'));
//const CRM_Catalogos = lazy(() => import('./pages/CRM_Catalogos'));
//const CRM_Reportes = lazy(() => import('./pages/CRM_Reportes'));
const CRM_Configuracion = lazy(() => import('./pages/CRM_Configuracion'));

// Adquisiciones
const ADQUISICIONES_Compras = lazy(() => import('./pages/ADQUISICIONES_Compras'));
const ADQUISICIONES_RecepcionHistorica = lazy(() => import('./pages/ADQUISICIONES_RecepcionHistorica'));
const ADQUISICIONES_ComprasDetalles = lazy(() => import('./pages/ADQUISICIONES_ComprasDetalles'));
const ADQUISICIONES_Proveedores = lazy(() => import('./pages/ADQUISICIONES_Proveedores'));
const ADQUISICIONES_ProveedoresCargaMasiva = lazy(() => import('./pages/ADQUISICIONES_ProveedoresCargaMasiva'));
const ADQUISICIONES_ProveedoresEditar = lazy(() => import('./pages/ADQUISICIONES_ProveedoresEditar'));
const ADQUISICIONES_NotasCredito = lazy(() => import('./pages/ADQUISICIONES_NotasCredito'));
const ADQUISICIONES_NotasCreditoDetalles = lazy(() => import('./pages/ADQUISICIONES_NotasCreditoDetalles'));

// Automotriz
const AUTOMOTRIZ_Vehiculos = lazy(() => import('./pages/AUTOMOTRIZ_Vehiculos'));
const AUTOMOTRIZ_VehiculoDetalle = lazy(() => import('./pages/AUTOMOTRIZ_VehiculoDetalle'));
const AUTOMOTRIZ_VehiculoEditar = lazy(() => import('./pages/AUTOMOTRIZ_VehiculoEditar'));
const AUTOMOTRIZ_VehiculoNuevo = lazy(() => import('./pages/AUTOMOTRIZ_VehiculoNuevo'));
const AUTOMOTRIZ_Mantenciones = lazy(() => import('./pages/AUTOMOTRIZ_Mantenciones'));
const AUTOMOTRIZ_MantencionNueva = lazy(() => import('./pages/AUTOMOTRIZ_MantencionNueva'));
const AUTOMOTRIZ_MantencionDetalle = lazy(() => import('./pages/AUTOMOTRIZ_MantencionDetalle'));
const AUTOMOTRIZ_CatalogoVehiculos = lazy(() => import('./pages/AUTOMOTRIZ_CatalogoVehiculos'));

// Inventario
const INVENTARIO_Productos = lazy(() => import('./pages/INVENTARIO_Productos'));
const INVENTARIO_ProductoDetalles = lazy(() => import('./pages/INVENTARIO_ProductoDetalles'));
const INVENTARIO_EditarProducto = lazy(() => import('./pages/INVENTARIO_EditarProducto'));
const INVENTARIO_CrearProducto = lazy(() => import('./pages/INVENTARIO_CrearProducto'));
const INVENTARIO_CargaMasiva = lazy(() => import('./pages/INVENTARIO_CargaMasiva'));
const INVENTARIO_Bodegas = lazy(() => import('./pages/INVENTARIO_Bodegas'));
const INVENTARIO_BodegasDetalles = lazy(() => import('./pages/INVENTARIO_BodegasDetalles'));
const INVENTARIO_Tomas = lazy(() => import('./pages/INVENTARIO_Tomas'));
const INVENTARIO_TomasDetalles = lazy(() => import('./pages/INVENTARIO_TomasDetalles'));
const INVENTARIO_MovimientosManuales = lazy(() => import('./pages/INVENTARIO_MovimientosManuales'));
const INVENTARIO_Categorias = lazy(() => import('./pages/INVENTARIO_Categorias'));
const INVENTARIO_Kardex = lazy(() => import('./pages/INVENTARIO_Kardex'));
const INVENTARIO_Consumos = lazy(() => import('./pages/INVENTARIO_Consumos'));
const INVENTARIO_Informes = lazy(() => import('./pages/INVENTARIO_Informes'));
const INVENTARIO_Unidades = lazy(() => import('./pages/INVENTARIO_Unidades'));
const INVENTARIO_Marcas = lazy(() => import('./pages/INVENTARIO_Marcas'));
const INVENTARIO_Origenes = lazy(() => import('./pages/INVENTARIO_Origenes'));
const INVENTARIO_TrasladosInventario = lazy(() => import('./pages/INVENTARIO_TrasladosInventario'));
const INVENTARIO_RegularizacionCostos = lazy(() => import('./pages/INVENTARIO_RegularizacionCostos'));

// Contabilidad
const CONTABILIDAD_Dashboard = lazy(() => import('./pages/CONTABILIDAD_Dashboard'));
const CONTABILIDAD_Gastos = lazy(() => import('./pages/CONTABILIDAD_Gastos'));
const CONTABILIDAD_PagosMasivos = lazy(() => import('./pages/CONTABILIDAD_PagosMasivos'));
const CONTABILIDAD_PlanDeCuentas = lazy(() => import('./pages/CONTABILIDAD_PlanDeCuentas'));
const CONTABILIDAD_RegistrosContables = lazy(() => import('./pages/CONTABILIDAD_RegistrosContables'));
const CONTABILIDAD_RegistroContableDetalle = lazy(() => import('./pages/CONTABILIDAD_RegistroContableDetalle'));
const CONTABILIDAD_Balances = lazy(() => import('./pages/CONTABILIDAD_Balances'));

// Tesorería
const TESORERIA_Dashboard = lazy(() => import('./pages/TESORERIA_Dashboard'));
const TESORERIA_Cuentas = lazy(() => import('./pages/TESORERIA_Cuentas'));
const TESORERIA_CuentaDetalle = lazy(() => import('./pages/TESORERIA_CuentaDetalle'));
const TESORERIA_Movimientos = lazy(() => import('./pages/TESORERIA_Movimientos'));
const TESORERIA_MovimientosDetalles = lazy(() => import('./pages/TESORERIA_MovimientosDetalles'));
const TESORERIA_Transferencias = lazy(() => import('./pages/TESORERIA_Transferencias'));
const TESORERIA_ConciliacionBancaria = lazy(() => import('./pages/TESORERIA_ConciliacionBancaria'));
const TESORERIA_ConfiguracionPagos = lazy(() => import('./pages/TESORERIA_ConfiguracionPagos'));
const TESORERIA_Liquidaciones = lazy(() => import('./pages/TESORERIA_Liquidaciones'));
const TESORERIA_MetodosContabilidad = lazy(() => import('./pages/TESORERIA_MetodosContabilidad'));
const TESORERIA_Pagos = lazy(() => import('./pages/TESORERIA_Pagos'));

// Finanzas
const FINANZAS_Resumen = lazy(() => import('./pages/FINANZAS_Resumen'));
const FINANZAS_Movimientos = lazy(() => import('./pages/FINANZAS_Movimientos'));
const FINANZAS_Operaciones = lazy(() => import('./pages/FINANZAS_Operaciones'));
const FINANZAS_Liquidaciones = lazy(() => import('./pages/FINANZAS_Liquidaciones'));
const FINANZAS_Configuracion = lazy(() => import('./pages/FINANZAS_Configuracion'));
const FINANZAS_Cuentas = lazy(() => import('./pages/FINANZAS_Cuentas'));
const FINANZAS_MetodosPago = lazy(() => import('./pages/FINANZAS_MetodosPago'));
const FINANZAS_CondicionesPago = lazy(() => import('./pages/FINANZAS_CondicionesPago'));
const FINANZAS_MetodosCuentas = lazy(() => import('./pages/FINANZAS_MetodosCuentas'));

// Ventas
const VENTAS_Cotizaciones = lazy(() => import('./pages/VENTAS_Cotizaciones'));
const VENTAS_CotizacionesCrear = lazy(() => import('./pages/VENTAS_CotizacionesCrear'));
const VENTAS_CotizacionesDetalles = lazy(() => import('./pages/VENTAS_CotizacionesDetalles'));
const VENTAS_CotizacionesEditar = lazy(() => import('./pages/VENTAS_CotizacionesEditar'));
const VENTAS_Clientes = lazy(() => import('./pages/VENTAS_Clientes'));
const VENTAS_ClientesDetalles = lazy(() => import('./pages/VENTAS_ClientesDetalles'));
const VENTAS_Ventas = lazy(() => import('./pages/VENTAS_Ventas'));
const VENTAS_VentasDetalles = lazy(() => import('./pages/VENTAS_VentasDetalles'));
const VENTAS_Reglas = lazy(() => import('./pages/VENTAS_Reglas'));
const VENTAS_VentasCrear = lazy(() => import('./pages/VENTAS_VentasCrear'));
const VENTAS_Pedidos = lazy(() => import('./pages/VENTAS_Pedidos'));
const VENTAS_PedidosDetalles = lazy(() => import('./pages/VENTAS_PedidosDetalles'));
const VENTAS_PedidosCrear = lazy(() => import('./pages/VENTAS_PedidosCrear'));
const VENTAS_PedidosEditar = lazy(() => import('./pages/VENTAS_PedidosEditar'));
const VENTAS_Pagos = lazy(() => import('./pages/VENTAS_Pagos'));

// Facturación
const FACTURACION_Folios = lazy(() => import('./pages/FACTURACION_Folios'));
const FACTURACION_LibroCompras = lazy(() => import('./pages/FACTURACION_LibroCompras'));
const FACTURACION_LibroVentas = lazy(() => import('./pages/FACTURACION_LibroVentas'));
const FACTURACION_Certificados = lazy(() => import('./pages/FACTURACION_Certificados'));
const FACTURACION_Config = lazy(() => import('./pages/FACTURACION_Config'));
const FACTURACION_Resumen = lazy(() => import('./pages/FACTURACION_Resumen'));
const FACTURACION_NotasCredito = lazy(() => import('./pages/FACTURACION_NotasCredito'));
const FACTURACION_NotasCreditoEmitir = lazy(() => import('./pages/FACTURACION_NotasCreditoEmitir'));
const FACTURACION_NotasCreditoDetalles = lazy(() => import('./pages/FACTURACION_NotasCreditoDetalles'));
const FACTURACION_NotasDebito = lazy(() => import('./pages/FACTURACION_NotasDebito'));
const FACTURACION_NotaDebitoEmitir = lazy(() => import('./pages/FACTURACION_NotaDebitoEmitir'));
const FACTURACION_NotaDebitoDetalles = lazy(() => import('./pages/FACTURACION_NotaDebitoDetalles'));
const FACTURACION_Boletas = lazy(() => import('./pages/FACTURACION_Boletas'));
const FACTURACION_FacturasAfectas = lazy(() => import('./pages/FACTURACION_FacturasAfectas'));
const FACTURACION_FacturasExentas = lazy(() => import('./pages/FACTURACION_FacturasExentas'));
const DTE_ImportaXML = lazy(() => import('./pages/DTE_ImportaXML'));

// Configuraciones / Usuario / Logística / RRHH / Integraciones / Gestión / Herramientas
const CONFIGURACIONES_Generales = lazy(() => import('./pages/CONFIGURACIONES_Generales'));
const CONFIGURACIONES_Empresa = lazy(() => import('./pages/CONFIGURACIONES_Empresa'));
const USUARIO_MiPerfil = lazy(() => import('./pages/USUARIO_MiPerfil'));
const LOGISTICA_Despachos = lazy(() => import('./pages/LOGISTICA_Despachos'));
const LOGISTICA_GestionDespachos = lazy(() => import('./pages/LOGISTICA_GestionDespachos'));
const LOGISTICA_Administracion = lazy(() => import('./pages/LOGISTICA_Administracion'));

// Configuraciones y gestión RRHH 
const RRHH_Catalogos = lazy(() => import('./pages/RRHH_Catalogos'));
const RRHH_Contratos = lazy(() => import('./pages/RRHH_Contratos'));
const RRHH_TrabajadoresLista = lazy(() => import('./pages/RRHH_TrabajadoresLista'));
const RRHH_TrabajadorFicha = lazy(() => import('./pages/RRHH_TrabajadorFicha'));
const RRHH_AsistenciaResumen = lazy(() => import('./pages/RRHH_AsistenciaResumen'));
const RRHH_AsistenciaMarcaciones = lazy(() => import('./pages/RRHH_AsistenciaMarcaciones'));
const RRHH_AsistenciaNovedades = lazy(() => import('./pages/RRHH_AsistenciaNovedades'));
const RRHH_Turnos = lazy(() => import('./pages/RRHH_Turnos'));
const RRHH_TurnosAsignacion = lazy(() => import('./pages/RRHH_TurnosAsignacion'));
const RRHH_AsistenciaCalendario = lazy(() => import('./pages/RRHH_AsistenciaCalendario'));
const RRHH_Ausencias = lazy(() => import('./pages/RRHH_Ausencias'));
const RRHH_Liquidaciones = lazy(() => import('./pages/RRHH_Liquidaciones'));
const RRHH_Asistencia = lazy(() => import('./pages/RRHH_Asistencia'));
const RRHH_PortalTrabajador = lazy(() => import('./pages/RRHH_PortalTrabajador'));
const RRHH_ConceptosRemuneracion = lazy(() => import('./pages/RRHH_ConceptosRemuneracion'));
const RRHH_ParametrosRemuneraciones = lazy(() => import('./pages/RRHH_ParametrosRemuneraciones'));
const RRHH_NovedadesLiquidacion = lazy(() => import('./pages/RRHH_NovedadesLiquidacion'));

const INTEGRACIONES_Mercadolibre = lazy(() => import('./pages/INTEGRACIONES_Mercadolibre'));
const INTEGRACIONES_Jumpseller = lazy(() => import('./pages/INTEGRACIONES_Jumpseller'));
const MERCADOLIBRE_SyncCenter = lazy(() => import('./pages/MERCADOLIBRE_SyncCenter'));
const GESTOR_Cajas = lazy(() => import('./pages/GESTOR_Cajas'));
const Herramientas = lazy(() => import('./pages/Herramientas'));
const UTILIDADES_Reportes = lazy(() => import('./pages/UTILIDADES_Reportes'));
const DTE_Certificacion = lazy(() => import('./pages/DTE_Certificacion'));

/* ─────────────────────────── REPORTES ──────────────────────────── */
const REPORTES_RentabilidadVentas = lazy(() => import('./pages/REPORTES_RentabilidadVentas'));
const REPORTES_RentabilidadProductos = lazy(() => import('./pages/REPORTES_RentabilidadProductos'));

/* ────────────────────────────── SALUD ────────────────────────────── */
const SALUD_Dashboard = lazy(() => import('./pages/SALUD_Dashboard'));
const SALUD_Agenda = lazy(() => import('./pages/SALUD_Agenda'));
const SALUD_Pacientes = lazy(() => import('./pages/SALUD_Pacientes'));
const SALUD_PacienteFicha = lazy(() => import('./pages/SALUD_PacienteFicha'));
const SALUD_Profesionales = lazy(() => import('./pages/SALUD_Profesionales'));
const SALUD_Prestaciones = lazy(() => import('./pages/SALUD_Prestaciones'));
const SALUD_Atenciones = lazy(() => import('./pages/SALUD_Atenciones'));
const SALUD_AtencionFicha = lazy(() => import('./pages/SALUD_AtencionFicha'));
const SALUD_Cirugias = lazy(() => import('./pages/SALUD_Cirugias'));
const SALUD_CirugiaFicha = lazy(() => import('./pages/SALUD_CirugiaFicha'));

/* ────────────────────────────── WEBSTORE ────────────────────────────── */
const WEBSTORE_Administracion = lazy(() => import('./pages/WEBSTORE_Administracion'));

/* ────────────────────────────── ACCESO Y PERMISOS ────────────────────────────── */

const ACCESS_DENIED_PATH = '/sin-acceso';
const AUTH_RETURN_PATH_KEY = 'authReturnPath';
const AUTH_STORAGE_KEYS = new Set(['token', 'tenantid']);
const AUTH_OFFLINE_TIMEOUT_MS = 6000;

function isRecoverableAuthConnectivityError(error) {
  if (!error) return false;

  const status = Number(error?.response?.status || 0);
  const code = String(error?.code || '').toUpperCase();

  if (!error.response) return true;
  if (['ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK'].includes(code)) return true;

  return (
    [408, 425, 429, 500, 502, 503, 504, 530].includes(status) ||
    (status >= 520 && status <= 527)
  );
}


const DEFAULT_ENTRY_ROUTES = [
  { path: '/', permission: 'home:inicio:ver' },
  { path: '/apps', permission: 'apps:portal:ver' },
  { path: '/crm', permission: 'crm:dashboard:ver' },
  { path: '/rrhh/portal', permission: 'rrhh:portal:ver-propia' },
  { path: '/rrhh/asistencia', permission: 'rrhh:asistencia:ver-propia' },
  { path: '/pos', permission: 'pos:terminal:ver' },
  { path: '/pos/administrativo', permission: 'pos:terminal:ver' },
  { path: '/mi-perfil', permission: 'usuario:mi-perfil:ver' },
];

const R = (path, Component, permissions, options = {}) => ({ path, Component, permissions, ...options });

const APP_ROUTE_DEFINITIONS = [
  // Inicio / Apps
  R('/mi-perfil', USUARIO_MiPerfil, ['usuario:mi-perfil:ver']),
  R('/apps', INTEGRANUBE_PortalApps, ['apps:portal:ver'], { passLogout: true }),
  R('/apps/inventario', APP_InventarioRapido, ['apps:inventario-rapido:ver']),
  R('/pos/administrativo', POS_Administrativo, ['pos:terminal:ver']),

  // CRM
  R('/crm', CRM_Dashboard, ['crm:dashboard:ver']),
  R('/crm/dashboard', CRM_Dashboard, ['crm:dashboard:ver']),
  //R('/crm/contactos', CRM_Contactos, ['crm:contactos:ver']),
  //R('/crm/contactos/crear', CRM_ContactosCrear, ['crm:contactos:crear']),
  //R('/crm/contactos/carga-masiva', CRM_ContactosCargaMasiva, ['crm:contactos:carga-masiva']),
  //R('/crm/contactos/:id', CRM_ContactosDetalle, ['crm:contactos:ver']),
  //R('/crm/contactos/:id/editar', CRM_ContactosEditar, ['crm:contactos:editar']),
  //R('/crm/empresas', CRM_Empresas, ['crm:empresas:ver']),
  //R('/crm/empresas/crear', CRM_EmpresasCrear, ['crm:empresas:crear']),
  //R('/crm/empresas/carga-masiva', CRM_EmpresasCargaMasiva, ['crm:empresas:carga-masiva']),
  //R('/crm/empresas/:id', CRM_EmpresasDetalle, ['crm:empresas:ver']),
  //R('/crm/empresas/:id/editar', CRM_EmpresasEditar, ['crm:empresas:editar']),
  //R('/crm/oportunidades', CRM_Oportunidades, ['crm:oportunidades:ver']),
  //R('/crm/oportunidades/crear', CRM_OportunidadesCrear, ['crm:oportunidades:crear']),
  //R('/crm/oportunidades/:id', CRM_OportunidadesDetalle, ['crm:oportunidades:ver']),
  //R('/crm/oportunidades/:id/editar', CRM_OportunidadesEditar, ['crm:oportunidades:editar']),
  R('/crm/casos', CRM_Casos, ['crm:casos:ver']),
  R('/crm/casos/crear', CRM_CasosCrear, ['crm:casos:crear']),
  R('/crm/casos/:id', CRM_CasosDetalle, ['crm:casos:ver']),
  //R('/crm/casos/:id/editar', CRM_CasosEditar, ['crm:casos:editar']),
  //R('/crm/actividades', CRM_Actividades, ['crm:actividades:ver']),
  //R('/crm/actividades/crear', CRM_ActividadesCrear, ['crm:actividades:crear']),
  //R('/crm/actividades/:id', CRM_ActividadesDetalle, ['crm:actividades:ver']),
  //R('/crm/actividades/:id/editar', CRM_ActividadesEditar, ['crm:actividades:editar']),
  //R('/crm/campanas', CRM_Campanas, ['crm:campanas:ver']),
  //R('/crm/campanas/crear', CRM_CampanasCrear, ['crm:campanas:crear']),
  //R('/crm/campanas/:id', CRM_CampanasDetalle, ['crm:campanas:ver']),
  //R('/crm/campanas/:id/editar', CRM_CampanasEditar, ['crm:campanas:editar']),
  //R('/crm/seguimientos', CRM_Seguimientos, ['crm:seguimientos:ver']),
  //R('/crm/catalogos', CRM_Catalogos, ['crm:catalogos:ver']),
  //R('/crm/reportes', CRM_Reportes, ['crm:reportes:ver']),
  R('/crm/configuracion', CRM_Configuracion, ['crm:configuracion:ver']),

  // Automotriz
  R('/automotriz/vehiculos', AUTOMOTRIZ_Vehiculos, ['automotriz:vehiculos:ver']),
  R('/automotriz/vehiculos/:id', AUTOMOTRIZ_VehiculoDetalle, ['automotriz:vehiculos:ver']),
  R('/automotriz/vehiculos/:id/editar', AUTOMOTRIZ_VehiculoEditar, ['automotriz:vehiculos:editar']),
  R('/automotriz/vehiculos/nuevo', AUTOMOTRIZ_VehiculoNuevo, ['automotriz:vehiculos:crear']),
  R('/automotriz/mantenciones', AUTOMOTRIZ_Mantenciones, ['automotriz:mantenciones:ver']),
  R('/automotriz/mantenciones/nueva', AUTOMOTRIZ_MantencionNueva, ['automotriz:mantenciones:crear']),
  R('/automotriz/mantenciones/:id', AUTOMOTRIZ_MantencionDetalle, ['automotriz:mantenciones:ver']),
  R('/automotriz/catalogo', AUTOMOTRIZ_CatalogoVehiculos, ['automotriz:catalogo:ver']),

  // Inventario
  R('/inventario', INVENTARIO_Productos, ['inventario:productos:ver']),
  R('/inventario/ver/:id', INVENTARIO_ProductoDetalles, ['inventario:productos:ver']),
  R('/inventario/editar/:id', INVENTARIO_EditarProducto, ['inventario:productos:editar']),
  R('/inventario/crear', INVENTARIO_CrearProducto, ['inventario:productos:crear']),
  R('/inventario/carga-masiva', INVENTARIO_CargaMasiva, ['inventario:productos:carga-masiva']),
  R('/inventario/categorias', INVENTARIO_Categorias, ['inventario:categorias:ver']),
  R('/inventario/marcas', INVENTARIO_Marcas, ['inventario:marcas:ver']),
  R('/inventario/origenes', INVENTARIO_Origenes, ['inventario:origenes:ver']),
  R('/inventario/informes', INVENTARIO_Informes, ['inventario:informes:ver']),
  R('/inventario/movimientos-manuales', INVENTARIO_MovimientosManuales, ['inventario:movimientos-manuales:ver']),
  R('/inventario/tomas', INVENTARIO_Tomas, ['inventario:tomas:ver']),
  R('/inventario/tomas/:id', INVENTARIO_TomasDetalles, ['inventario:tomas:ver']),
  R('/inventario/bodegas', INVENTARIO_Bodegas, ['inventario:bodegas:ver']),
  R('/inventario/bodegas/:id', INVENTARIO_BodegasDetalles, ['inventario:bodegas:ver']),
  R('/inventario/kardex', INVENTARIO_Kardex, ['inventario:kardex:ver']),
  R('/inventario/consumos', INVENTARIO_Consumos, ['inventario:consumos:ver']),
  R('/inventario/unidades', INVENTARIO_Unidades, ['inventario:unidades:ver']),
  R('/inventario/traslados', INVENTARIO_TrasladosInventario, ['inventario:traslados:ver']),
  R('/inventario/regularizacion-costos', INVENTARIO_RegularizacionCostos, ['inventario:traslados:ver']),

  // Configuraciones
  R('/configuraciones/empresa', CONFIGURACIONES_Empresa, ['configuraciones:empresa:ver']),
  R('/configuraciones/generales', CONFIGURACIONES_Generales, ['configuraciones:generales:ver']),

  // RRHH
  R('/rrhh/catalogos', RRHH_Catalogos, ['rrhh:catalogos:ver']),
  R('/rrhh/asistencia', RRHH_Asistencia, ['rrhh:asistencia:ver-propia', 'rrhh:asistencia-resumen:ver']),
  R('/rrhh/asistencia/marcaciones', RRHH_AsistenciaMarcaciones, ['rrhh:marcaciones:ver']),
  R('/rrhh/asistencia-novedades', RRHH_AsistenciaNovedades, ['rrhh:marcaciones:ver']),
  R('/rrhh/trabajadores', RRHH_TrabajadoresLista, ['rrhh:trabajadores:ver']),
  R('/rrhh/trabajadores/:id', RRHH_TrabajadorFicha, ['rrhh:trabajadores:ver']),
  R('/rrhh/contratos', RRHH_Contratos, ['rrhh:contratos:ver']),
  R('/rrhh/asistencia/resumen', RRHH_AsistenciaResumen, ['rrhh:asistencia-resumen:ver']),
  R('/rrhh/ausencias', RRHH_Ausencias, ['rrhh:ausencias:ver']),
  R('/rrhh/asistencia/calendario', RRHH_AsistenciaCalendario, ['rrhh:calendario:ver']),
  R('/rrhh/turnos', RRHH_Turnos, ['rrhh:turnos:ver']),
  R('/rrhh/turnos/asignacion', RRHH_TurnosAsignacion, ['rrhh:turnos:asignar']),
  R('/rrhh/liquidaciones', RRHH_Liquidaciones, ['rrhh:liquidaciones:ver']),
  R('/rrhh/portal', RRHH_PortalTrabajador, ['rrhh:portal:ver-propia']),
  R('/rrhh/parametros-remuneraciones', RRHH_ParametrosRemuneraciones, ['rrhh:catalogos:ver']),
  R('/rrhh/conceptos-remuneracion', RRHH_ConceptosRemuneracion, ['rrhh:catalogos:ver']),
  R('/rrhh/novedades-liquidacion', RRHH_NovedadesLiquidacion, ['rrhh:catalogos:ver']),

  // Integraciones / Gestión
  R('/integraciones/jumpseller', INTEGRACIONES_Jumpseller, ['integraciones:jumpseller:ver']),
  R('/integraciones/mercadolibre', INTEGRACIONES_Mercadolibre, ['integraciones:mercadolibre:ver']),
  R('/gestor/mercadolibre', MERCADOLIBRE_SyncCenter, ['integraciones:mercadolibre:gestor:ver']),
  R('/gestor/cajas', GESTOR_Cajas, ['caja:gestion:ver']),
  R('/imbrasync', ImbraSyncPage, ['integraciones:imbrasync:ejecutar']),

  // Adquisiciones
  R('/compras', ADQUISICIONES_Compras, ['adquisiciones:compras:ver']),
  R('/compras/:id', ADQUISICIONES_ComprasDetalles, ['adquisiciones:compras:ver']),
  R('/compras/historicas', ADQUISICIONES_RecepcionHistorica, ['adquisiciones:compras:ver']),
  R('/compras/historicas/:id', ADQUISICIONES_RecepcionHistorica, ['adquisiciones:compras:ver']),
  R('/adquisiciones/notas-credito', ADQUISICIONES_NotasCredito, ['adquisiciones:notas-credito:ver']),
  R('/adquisiciones/notas-credito/:id', ADQUISICIONES_NotasCreditoDetalles, ['adquisiciones:notas-credito:ver']),
  R('/proveedores', ADQUISICIONES_Proveedores, ['adquisiciones:proveedores:ver']),
  R('/proveedores/:rut', ADQUISICIONES_ProveedoresEditar, ['adquisiciones:proveedores:editar']),
  R('/proveedores/carga-masiva', ADQUISICIONES_ProveedoresCargaMasiva, ['adquisiciones:proveedores:carga-masiva']),

  // Tesorería
  R('/tesoreria', TESORERIA_Dashboard, ['tesoreria:dashboard:ver']),
  R('/tesoreria/cuentas', TESORERIA_Cuentas, ['tesoreria:cuentas:ver']),
  R('/tesoreria/cuentas/:id', TESORERIA_CuentaDetalle, ['tesoreria:cuentas:ver']),
  R('/tesoreria/movimientos', TESORERIA_Movimientos, ['tesoreria:movimientos:ver']),
  R('/tesoreria/movimientos/:id', TESORERIA_MovimientosDetalles, ['tesoreria:movimientos:ver']),
  R('/tesoreria/transferencias', TESORERIA_Transferencias, ['tesoreria:transferencias:ver']),
  R('/tesoreria/transferencias/nueva', TESORERIA_Transferencias, ['tesoreria:transferencias:crear']),
  R('/tesoreria/conciliacion-bancaria', TESORERIA_ConciliacionBancaria, ['tesoreria:conciliacion-bancaria:ver']),
  R('/tesoreria/liquidaciones', TESORERIA_Liquidaciones, ['tesoreria:liquidaciones:ver']),
  R('/tesoreria/pagos', TESORERIA_Pagos, ['tesoreria:pagos:ver']),
  R('/tesoreria/configuracion-pagos', TESORERIA_ConfiguracionPagos, ['tesoreria:configuracion-pagos:ver']),
  R('/tesoreria/metodos-contabilidad', TESORERIA_MetodosContabilidad, ['tesoreria:metodos-contabilidad:ver']),

  // Finanzas
  R('/finanzas', FINANZAS_Resumen, ['finanzas:movimientos:ver']),
  R('/finanzas/resumen', FINANZAS_Resumen, ['finanzas:movimientos:ver']),
  R('/finanzas/movimientos', FINANZAS_Movimientos, ['finanzas:movimientos:ver']),
  R('/finanzas/operaciones', FINANZAS_Operaciones, ['finanzas:operaciones:ver']),
  R('/finanzas/liquidaciones', FINANZAS_Liquidaciones, ['finanzas:liquidaciones:ver']),
  R('/finanzas/configuracion', FINANZAS_Configuracion, ['finanzas:cuentas:ver','finanzas:metodos:ver','finanzas:condiciones:ver']),
  R('/finanzas/cuentas', FINANZAS_Cuentas, ['finanzas:cuentas:ver']),
  R('/finanzas/metodos-pago', FINANZAS_MetodosPago, ['finanzas:metodos:ver']),
  R('/finanzas/condiciones-pago', FINANZAS_CondicionesPago, ['finanzas:condiciones:ver']),
  R('/finanzas/metodos-cuentas', FINANZAS_MetodosCuentas, ['finanzas:metodos:ver']),

  // Ventas
  R('/ventas', VENTAS_Ventas, ['ventas:ventas:ver']),
  R('/ventas/crear', VENTAS_VentasCrear, ['ventas:ventas:crear']),
  R('/ventas/:id', VENTAS_VentasDetalles, ['ventas:ventas:ver']),
  R('/ventas/editar/:id', VENTAS_VentasDetalles, ['ventas:ventas:editar']),
  R('/ventas/pedidos', VENTAS_Pedidos, ['ventas:pedidos:ver']),
  R('/ventas/reglas', VENTAS_Reglas, ['ventas:reglas:ver']),
  R('/ventas/pedidos/:id', VENTAS_PedidosDetalles, ['ventas:pedidos:ver']),
  R('/ventas/pedidos/crear', VENTAS_PedidosCrear, ['ventas:pedidos:crear']),
  R('/ventas/pedidos/:id/editar', VENTAS_PedidosEditar, ['ventas:pedidos:editar']),
  R('/ventas/pagos', VENTAS_Pagos, ['ventas:pagos:ver']),
  R('/ventas/cotizaciones', VENTAS_Cotizaciones, ['ventas:cotizaciones:ver']),
  R('/ventas/cotizaciones/crear', VENTAS_CotizacionesCrear, ['ventas:cotizaciones:crear']),
  R('/ventas/cotizaciones/:id', VENTAS_CotizacionesDetalles, ['ventas:cotizaciones:ver']),
  R('/ventas/cotizaciones/:id/editar', VENTAS_CotizacionesEditar, ['ventas:cotizaciones:editar']),
  R('/ventas/clientes', VENTAS_Clientes, ['ventas:clientes:ver']),
  R('/ventas/clientes/:id', VENTAS_ClientesDetalles, ['ventas:clientes:ver']),
  R('/ventas/clientes/crear', VENTAS_ClientesDetalles, ['ventas:clientes:crear']),

  // Logística
  R('/logistica/despachos', LOGISTICA_Despachos, ['logistica:despachos:ver']),
  R('/logistica/despachos/:pedidoId', LOGISTICA_GestionDespachos, ['logistica:despachos:ver']),
  R('/logistica/administracion', LOGISTICA_Administracion, ['logistica:administracion:ver']),

  // Contabilidad
  R('/contabilidad/dashboard', CONTABILIDAD_Dashboard, ['contabilidad:dashboard:ver']),
  R('/contabilidad/gastos', CONTABILIDAD_Gastos, ['contabilidad:gastos:ver']),
  R('/contabilidad/pagos-masivos', CONTABILIDAD_PagosMasivos, ['contabilidad:pagos-masivos:ver']),
  R('/contabilidad/plan-de-cuentas', CONTABILIDAD_PlanDeCuentas, ['contabilidad:plan-cuentas:ver']),
  R('/contabilidad/balances', CONTABILIDAD_Balances, ['contabilidad:balances:ver']),
  R('/contabilidad/registros-contables', CONTABILIDAD_RegistrosContables, ['contabilidad:registros:ver']),
  R('/contabilidad/registros-contables/:id', CONTABILIDAD_RegistroContableDetalle, ['contabilidad:registros:ver']),

  // Facturación
  R('/facturacion', FACTURACION_Resumen, ['facturacion:resumen:ver']),
  R('/facturacion/notas-credito', FACTURACION_NotasCredito, ['facturacion:notas-credito:ver']),
  R('/facturacion/notas-credito/emitir', FACTURACION_NotasCreditoEmitir, ['facturacion:notas-credito:emitir']),
  R('/facturacion/notas-credito/:id', FACTURACION_NotasCreditoDetalles, ['facturacion:notas-credito:ver']),
  R('/facturacion/notas-debito', FACTURACION_NotasDebito, ['facturacion:notas-debito:ver']),
  R('/facturacion/notas-debito/emitir', FACTURACION_NotaDebitoEmitir, ['facturacion:notas-debito:emitir']),
  R('/facturacion/notas-debito/:id', FACTURACION_NotaDebitoDetalles, ['facturacion:notas-debito:ver']),
  R('/facturacion/boletas', FACTURACION_Boletas, ['facturacion:boletas:ver']),
  R('/facturacion/facturas-afectas', FACTURACION_FacturasAfectas, ['facturacion:facturas-afectas:ver']),
  R('/facturacion/facturas-exentas', FACTURACION_FacturasExentas, ['facturacion:facturas-exentas:ver']),
  R('/facturacion/timbraje-folios', FACTURACION_Folios, ['facturacion:folios:ver']),
  R('/facturacion/libro-compras', FACTURACION_LibroCompras, ['facturacion:libro-compras:ver']),
  R('/facturacion/libro-ventas', FACTURACION_LibroVentas, ['facturacion:libro-ventas:ver']),
  R('/facturacion/configuracion', FACTURACION_Config, ['facturacion:configuracion:ver']),
  R('/facturacion/certificados-sii', FACTURACION_Certificados, ['facturacion:certificados-sii:ver']),

  // Herramientas
  R('/herramientas', Herramientas, ['herramientas:general:ver']),
  R('/dte/certificacion', DTE_Certificacion, ['facturacion:certificacion:ver']),
  R('/dte/importaxml', DTE_ImportaXML, ['facturacion:importar-xml:ver']),

  // Reportes
  R('/reportes', UTILIDADES_Reportes, ['utilidades:reportes:ver']),
  R('/reportes/rentabilidad-ventas', REPORTES_RentabilidadVentas, ['reportes:reportes:ver']),
  R('/reportes/rentabilidad-productos', REPORTES_RentabilidadProductos, ['reportes:reportes:ver']),

  // Salud

  R('/salud', SALUD_Dashboard, ['salud:resumen:ver']),
  R('/salud/pacientes', SALUD_Pacientes, ['salud:pacientes:ver']),
  R('/salud/pacientes/:id', SALUD_PacienteFicha, ['salud:pacientes:ver']),
  R('/salud/agenda', SALUD_Agenda, ['salud:agenda:ver']),
  R('/salud/profesionales', SALUD_Profesionales, ['salud:profesionales:ver']),
  R('/salud/prestaciones', SALUD_Prestaciones, ['salud:prestaciones:ver']),
  R('/salud/atenciones', SALUD_Atenciones, ['salud:atenciones:ver']),
  R('/salud/atenciones/:id', SALUD_AtencionFicha, ['salud:atenciones:ver']),
  R('/salud/cirugias', SALUD_Cirugias, ['salud:cirugias:ver']),
  R('/salud/cirugias/:id', SALUD_CirugiaFicha, ['salud:cirugias:ver']),

  // Webstore - Administración
  R('/webstore/administracion', WEBSTORE_Administracion, ['webstore:administracion:ver']),
];

/* ────────────────────────────── HELPERS ────────────────────────────── */

function normalizeTenantId(value) {
  return String(value ?? '').trim();
}

function normalizePermissionName(value) {
  return String(value || '').trim().toLowerCase();
}

function safeJsonParse(value, fallback = null) {
  try {
    if (!value) return fallback;
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

function getTenantId(tenant) {
  return tenant?.tenantid || tenant?.tenantId || tenant?.tenant_id || tenant?.id_tenant || tenant?.id || null;
}

function getPermissionCode(permission) {
  if (typeof permission === 'string') return normalizePermissionName(permission);
  if (!permission || typeof permission !== 'object') return '';
  return normalizePermissionName(permission.name || permission.permission || permission.code || permission.clave || permission.permission_name);
}

function normalizePermissionList(value) {
  const list = Array.isArray(value) ? value : [];
  return [...new Set(list.map(getPermissionCode).filter(Boolean))];
}

function findCurrentTenantAccess(authPayload, activeTenantId) {
  const tenantId = normalizeTenantId(activeTenantId);
  const allowedTenants = Array.isArray(authPayload?.allowedTenants)
    ? authPayload.allowedTenants
    : Array.isArray(authPayload?.allowed_tenants)
      ? authPayload.allowed_tenants
      : [];

  const tenant = allowedTenants.find((item) => normalizeTenantId(getTenantId(item)) === tenantId);
  if (!tenant) return null;

  return { tenant, permissions: normalizePermissionList(tenant.permissions || tenant.permisos || []) };
}

function hasPermission(permissionSet, permissionName) {
  return permissionSet.has(normalizePermissionName(permissionName));
}

function getDefaultAuthorizedPath(permissionList) {
  const permissionSet = new Set(normalizePermissionList(permissionList));
  const match = DEFAULT_ENTRY_ROUTES.find((item) => hasPermission(permissionSet, item.permission));
  return match?.path || ACCESS_DENIED_PATH;
}

function getLoginRedirectPath(permissionList) {
  const host = String(window.location.hostname || '').toLowerCase();
  const permissionSet = new Set(normalizePermissionList(permissionList));

  if (host === 'pos.integranube.cl' && hasPermission(permissionSet, 'pos:terminal:ver')) return '/pos';
  if (host === 'crm.integranube.cl' && hasPermission(permissionSet, 'crm:dashboard:ver')) return '/crm';

  return getDefaultAuthorizedPath(permissionList);
}

function applySessionHeaders(token, tenantId) {
  const normalizedTenantId = normalizeTenantId(tenantId);
  const authorization = `Bearer ${token}`;

  [axios, api].forEach((client) => {
    if (!client?.defaults?.headers?.common) return;
    client.defaults.headers.common.Authorization = authorization;
    client.defaults.headers.common.tenantid = normalizedTenantId;
    client.defaults.headers.common.tenantId = normalizedTenantId;
  });
}

function clearSessionHeaders() {
  [axios, api].forEach((client) => {
    if (!client?.defaults?.headers?.common) return;
    delete client.defaults.headers.common.Authorization;
    delete client.defaults.headers.common.tenantid;
    delete client.defaults.headers.common.tenantId;
  });
}

function getCurrentBrowserPath() {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

function normalizeReturnPath(value) {
  const path = String(value || '').trim();
  if (!path || !path.startsWith('/') || path.startsWith('//')) return null;

  const pathname = path.split(/[?#]/, 1)[0] || '/';
  if (pathname === '/login' || pathname === ACCESS_DENIED_PATH) return null;

  return path;
}

function rememberReturnPath(path = getCurrentBrowserPath()) {
  const normalizedPath = normalizeReturnPath(path);
  if (!normalizedPath) return null;

  sessionStorage.setItem(AUTH_RETURN_PATH_KEY, normalizedPath);
  return normalizedPath;
}

function consumeReturnPath() {
  const savedPath = normalizeReturnPath(
    sessionStorage.getItem(AUTH_RETURN_PATH_KEY)
  );

  sessionStorage.removeItem(AUTH_RETURN_PATH_KEY);
  return savedPath;
}

function getRequestAuthorizationHeader(error) {
  const headers = error?.config?.headers;
  if (!headers) return '';

  if (typeof headers.get === 'function') {
    return headers.get('Authorization') || headers.get('authorization') || '';
  }

  return headers.Authorization || headers.authorization || '';
}

const POS_EXTERNAL_URL = 'https://pos.integranube.cl';

function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return <PageLoader />;
}

function PageLoader() {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', justifyContent: 'center', alignItems: 'center' }}>
      <CircularProgress />
    </Box>
  );
}

function AccessDeniedPage() {
  const location = useLocation();

  const storedAccessDenied = safeJsonParse(
    sessionStorage.getItem('lastAccessDenied'),
    {}
  );

  const accessDeniedInfo = {
    ...storedAccessDenied,
    ...(location.state || {}),
  };

  const requestedPath = accessDeniedInfo.from || null;
  const routePattern = accessDeniedInfo.routePattern || null;
  const reason = accessDeniedInfo.reason || 'MISSING_PERMISSION';

  const requiredPermissions = normalizePermissionList(
    accessDeniedInfo.requiredPermissions
  );

  const requiresAnyPermission = accessDeniedInfo.permissionMode !== 'ALL';
  const isUnknownRoute = reason === 'ROUTE_NOT_FOUND';

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'grid',
        placeItems: 'center',
        px: 2,
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 620,
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" fontWeight={800} gutterBottom>
          {isUnknownRoute ? 'Ruta no disponible' : 'Acceso no autorizado'}
        </Typography>

        <Typography color="text.secondary">
          {isUnknownRoute
            ? 'La dirección solicitada no corresponde a una sección configurada en el sistema.'
            : 'Su perfil no tiene permisos para acceder a esta sección. Solicite autorización a un administrador.'}
        </Typography>

        {(requestedPath || routePattern || requiredPermissions.length > 0) && (
          <Box
            sx={{
              mt: 3,
              p: 2.5,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
              bgcolor: 'background.paper',
              textAlign: 'left',
            }}
          >
            <Typography
              variant="overline"
              color="text.secondary"
              fontWeight={700}
            >
              Información para el administrador
            </Typography>

            {requestedPath && (
              <Box sx={{ mt: 1.5 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  fontWeight={700}
                  sx={{ display: 'block' }}
                >
                  Ruta solicitada
                </Typography>

                <Typography
                  component="code"
                  sx={{
                    display: 'block',
                    mt: 0.5,
                    p: 1,
                    borderRadius: 1,
                    bgcolor: 'action.hover',
                    fontFamily: 'monospace',
                    fontSize: '0.85rem',
                    overflowWrap: 'anywhere',
                  }}
                >
                  {requestedPath}
                </Typography>
              </Box>
            )}

            {routePattern && routePattern !== requestedPath && (
              <Box sx={{ mt: 2 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  fontWeight={700}
                  sx={{ display: 'block' }}
                >
                  Ruta configurada
                </Typography>

                <Typography
                  component="code"
                  sx={{
                    display: 'block',
                    mt: 0.5,
                    p: 1,
                    borderRadius: 1,
                    bgcolor: 'action.hover',
                    fontFamily: 'monospace',
                    fontSize: '0.85rem',
                    overflowWrap: 'anywhere',
                  }}
                >
                  {routePattern}
                </Typography>
              </Box>
            )}

            {requiredPermissions.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  fontWeight={700}
                  sx={{ display: 'block', mb: 1 }}
                >
                  {requiredPermissions.length === 1
                    ? 'Permiso requerido'
                    : requiresAnyPermission
                      ? 'Se requiere al menos uno de estos permisos'
                      : 'Se requieren todos estos permisos'}
                </Typography>

                <Stack
                  direction="row"
                  spacing={1}
                  useFlexGap
                  flexWrap="wrap"
                >
                  {requiredPermissions.map((permission) => (
                    <Chip
                      key={permission}
                      label={permission}
                      size="small"
                      variant="outlined"
                      sx={{
                        fontFamily: 'monospace',
                        fontWeight: 600,
                      }}
                    />
                  ))}
                </Stack>
              </Box>
            )}

            {isUnknownRoute && requiredPermissions.length === 0 && (
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: 'block', mt: 2 }}
              >
                No existe un permiso asociado porque la ruta no está registrada.
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
}

function PermissionRoute({
  isAuthenticated,
  permissions,
  requiredPermissions = [],
  routePattern,
  onForbidden,
  children,
}) {
  const location = useLocation();

  const permissionSet = useMemo(
    () => new Set(normalizePermissionList(permissions)),
    [permissions]
  );

  const normalizedRequirements = useMemo(
    () => normalizePermissionList(requiredPermissions),
    [requiredPermissions]
  );

  // Modo ANY: basta con que el usuario tenga uno de los permisos indicados.
  const isAllowed =
    normalizedRequirements.length === 0 ||
    normalizedRequirements.some((permission) =>
      hasPermission(permissionSet, permission)
    );

  const requestedPath = useMemo(
    () => `${location.pathname}${location.search}${location.hash}`,
    [location.pathname, location.search, location.hash]
  );

  const accessDeniedInfo = useMemo(
    () => ({
      from: requestedPath,
      routePattern: routePattern || location.pathname,
      requiredPermissions: normalizedRequirements,
      permissionMode: 'ANY',
      reason: 'MISSING_PERMISSION',
    }),
    [requestedPath, routePattern, location.pathname, normalizedRequirements]
  );

  useEffect(() => {
    if (!isAuthenticated || isAllowed) return;

    sessionStorage.setItem(
      'lastAccessDenied',
      JSON.stringify(accessDeniedInfo)
    );

    onForbidden?.(accessDeniedInfo);
  }, [isAuthenticated, isAllowed, accessDeniedInfo, onForbidden]);

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: requestedPath }}
      />
    );
  }

  if (!isAllowed) {
    return (
      <Navigate
        to={ACCESS_DENIED_PATH}
        replace
        state={accessDeniedInfo}
      />
    );
  }

  return children;
}

function LoginRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  const requestedPath = useMemo(
    () => `${location.pathname}${location.search}${location.hash}`,
    [location.pathname, location.search, location.hash]
  );

  useEffect(() => {
    rememberReturnPath(requestedPath);
    navigate('/login', {
      replace: true,
      state: { from: requestedPath },
    });
  }, [navigate, requestedPath]);

  return <PageLoader />;
}

function AuthenticatedLoginRedirect({ permissions }) {
  const navigate = useNavigate();

  useEffect(() => {
    const destination =
      consumeReturnPath() || getLoginRedirectPath(permissions);

    navigate(destination, { replace: true });
  }, [navigate, permissions]);

  return <PageLoader />;
}

function UnknownRouteRedirect() {
  const location = useLocation();
  const requestedPath = `${location.pathname}${location.search}${location.hash}`;

  const accessDeniedInfo = {
    from: requestedPath,
    routePattern: null,
    requiredPermissions: [],
    permissionMode: 'ANY',
    reason: 'ROUTE_NOT_FOUND',
  };

  useEffect(() => {
    sessionStorage.setItem(
      'lastAccessDenied',
      JSON.stringify(accessDeniedInfo)
    );
  }, [requestedPath]);

  return (
    <Navigate
      to={ACCESS_DENIED_PATH}
      replace
      state={accessDeniedInfo}
    />
  );
}

function RootEntry({ permissions }) {
  const destination = getDefaultAuthorizedPath(permissions);

  // Los perfiles con permiso de inicio administrativo permanecen en "/".
  if (destination === '/') {
    return <Inicio />;
  }

  // Los demás perfiles son enviados a su primera portada autorizada.
  return <Navigate to={destination} replace />;
}

/* ────────────────────────────── APP ────────────────────────────── */

function App() {
  const navigate = useNavigate();

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [tenantSelected, setTenantSelected] = useState(false);
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const notify = useCallback((message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  }, []);

  const handleLogout = useCallback(({
    showNotification = true,
    preserveCurrentPath = false,
  } = {}) => {
    if (preserveCurrentPath) rememberReturnPath();
    else sessionStorage.removeItem(AUTH_RETURN_PATH_KEY);

    setIsAuthenticated(false);
    setTenantSelected(false);
    setPermissions([]);
    setLoading(false);

    localStorage.removeItem('token');
    localStorage.removeItem('tenantid');
    localStorage.removeItem('tenant');
    localStorage.removeItem('user');

    clearSessionHeaders();
    navigate('/login', { replace: true });

    if (showNotification) notify('Sesión cerrada correctamente.', 'info');
  }, [navigate, notify]);

  const loadTenantPermissions = useCallback(async (tenantId, storedTenant) => {
    const response = await api.get('/auth/me', { timeout: AUTH_OFFLINE_TIMEOUT_MS });
    const payload = response?.data || {};
    const resolved = findCurrentTenantAccess(payload, tenantId);

    if (!resolved) {
      const error = new Error('La empresa seleccionada ya no está disponible para esta sesión.');
      error.code = 'TENANT_ACCESS_NOT_FOUND';
      throw error;
    }

    const currentTenant = {
      ...(storedTenant || {}),
      ...resolved.tenant,
      tenantid: getTenantId(resolved.tenant) || tenantId,
      permissions: resolved.permissions,
    };

    localStorage.setItem('tenant', JSON.stringify(currentTenant));
    if (payload.user) localStorage.setItem('user', JSON.stringify(payload.user));

    return { tenant: currentTenant, permissions: resolved.permissions };
  }, []);

  const verifyAuth = useCallback(async () => {
    const token = localStorage.getItem('token');
    const tenantId = localStorage.getItem('tenantid');

    setLoading(true);

    if (!token || !tenantId) {
      setIsAuthenticated(false);
      setTenantSelected(false);
      setPermissions([]);
      setLoading(false);
      return;
    }

    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decoded?.exp && decoded.exp < currentTime) {
        handleLogout({
          showNotification: false,
          preserveCurrentPath: true,
        });
        return;
      }

      applySessionHeaders(token, tenantId);

      const storedTenant = safeJsonParse(localStorage.getItem('tenant'), {});
      const storedTenantId = normalizeTenantId(getTenantId(storedTenant));
      const cachedPermissions = normalizePermissionList(
        storedTenant?.permissions || storedTenant?.permisos || []
      );

      try {
        const access = await loadTenantPermissions(tenantId, storedTenant);

        setPermissions(access.permissions);
        setIsAuthenticated(true);
        setTenantSelected(true);
      } catch (permissionError) {
        const canUseCachedAccess =
          isRecoverableAuthConnectivityError(permissionError) &&
          (!storedTenantId || storedTenantId === normalizeTenantId(tenantId)) &&
          cachedPermissions.length > 0;

        if (!canUseCachedAccess) {
          throw permissionError;
        }

        // Contingencia de arranque: el JWT sigue vigente y los permisos fueron
        // validados y almacenados en una sesión online anterior. No borramos
        // la sesión solo porque Cloudflare/API no respondan.
        setPermissions(cachedPermissions);
        setIsAuthenticated(true);
        setTenantSelected(true);

        notify(
          'Sin conexión con la API. Se utilizarán temporalmente los permisos guardados en este equipo.',
          'warning'
        );
      }
    } catch (error) {
      console.error('[App] Error validando sesión y permisos:', error);

      rememberReturnPath();

      setIsAuthenticated(false);
      setTenantSelected(false);
      setPermissions([]);

      clearSessionHeaders();

      localStorage.removeItem('token');
      localStorage.removeItem('tenantid');
      localStorage.removeItem('tenant');
      localStorage.removeItem('user');

      navigate('/login', { replace: true });

      notify(
        error?.code === 'TENANT_ACCESS_NOT_FOUND'
          ? 'La empresa seleccionada ya no está disponible para tu usuario.'
          : 'No fue posible validar la sesión y sus permisos.',
        'error'
      );
    } finally {
      setLoading(false);
    }
  }, [handleLogout, loadTenantPermissions, navigate, notify]);

  useEffect(() => {
    verifyAuth();
  }, [verifyAuth]);

  useEffect(() => {
    const interceptUnauthorized = (error) => {
      if (error?.response?.status === 401) {
        const currentToken = localStorage.getItem('token');
        const currentAuthorization = currentToken ? `Bearer ${currentToken}` : '';
        const requestAuthorization = getRequestAuthorizationHeader(error);

        // Si el 401 pertenece a una petición antigua, no debe cerrar una
        // sesión nueva que pudo haberse iniciado mientras la petición viajaba.
        const belongsToCurrentSession =
          !requestAuthorization || requestAuthorization === currentAuthorization;

        if (belongsToCurrentSession) {
          handleLogout({
            showNotification: false,
            preserveCurrentPath: true,
          });
        }
      }

      return Promise.reject(error);
    };

    const axiosInterceptor = axios.interceptors.response.use(
      (response) => response,
      interceptUnauthorized
    );

    const apiInterceptor = api !== axios
      ? api.interceptors.response.use(
          (response) => response,
          interceptUnauthorized
        )
      : null;

    return () => {
      axios.interceptors.response.eject(axiosInterceptor);
      if (apiInterceptor !== null) api.interceptors.response.eject(apiInterceptor);
    };
  }, [handleLogout]);

  useEffect(() => {
    let syncTimer = null;

    const handleStorageChange = (event) => {
      if (!AUTH_STORAGE_KEYS.has(event.key)) return;

      if (syncTimer) window.clearTimeout(syncTimer);

      // Login/logout cambia varias claves seguidas. Esperamos brevemente para
      // validar una sola vez cuando el estado compartido ya quedó consistente.
      syncTimer = window.setTimeout(() => {
        verifyAuth();
      }, 75);
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      if (syncTimer) window.clearTimeout(syncTimer);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [verifyAuth]);

  const handleLogin = useCallback(async ({ user, token, tenant }) => {
    const tenantId = getTenantId(tenant);

    if (!tenantId) {
      notify('No fue posible identificar la empresa seleccionada.', 'error');
      return;
    }

    setLoading(true);

    try {
      localStorage.setItem('token', token);
      localStorage.setItem('tenantid', tenantId);
      localStorage.setItem('tenant', JSON.stringify(tenant || {}));
      localStorage.setItem('user', JSON.stringify(user || {}));

      applySessionHeaders(token, tenantId);

      const access = await loadTenantPermissions(tenantId, tenant);

      setPermissions(access.permissions);
      setIsAuthenticated(true);
      setTenantSelected(true);

      const destination =
        consumeReturnPath() || getLoginRedirectPath(access.permissions);

      notify('Inicio de sesión exitoso.', 'success');
      navigate(destination, { replace: true });
    } catch (error) {
      console.error('[App] Error cargando permisos después del login:', error);

      setIsAuthenticated(false);
      setTenantSelected(false);
      setPermissions([]);

      localStorage.removeItem('token');
      localStorage.removeItem('tenantid');
      localStorage.removeItem('tenant');
      localStorage.removeItem('user');

      clearSessionHeaders();

      notify(
        error?.code === 'TENANT_ACCESS_NOT_FOUND'
          ? 'La empresa seleccionada no está disponible para tu usuario.'
          : 'No fue posible cargar los permisos del usuario.',
        'error'
      );
    } finally {
      setLoading(false);
    }
  }, [loadTenantPermissions, navigate, notify]);

  const handleForbidden = useCallback((accessDeniedInfo) => {
    const path = accessDeniedInfo?.from || 'esta sección';

    const requiredPermissions = normalizePermissionList(
      accessDeniedInfo?.requiredPermissions
    );

    let message = `No tienes permisos para acceder a ${path}.`;

    if (requiredPermissions.length === 1) {
      message += ` Permiso requerido: ${requiredPermissions[0]}.`;
    } else if (requiredPermissions.length > 1) {
      message += ` Se requiere uno de estos permisos: ${requiredPermissions.join(', ')}.`;
    }

    notify(message, 'warning');
  }, [notify]);

  const renderApplicationRoute = useCallback(({
    path,
    Component,
    permissions: requiredPermissions,
    passLogout,
  }) => {
    const page = passLogout ? <Component onLogout={handleLogout} /> : <Component />;

    return (
      <Route
        key={path}
        path={path}
        element={
          <PermissionRoute
            isAuthenticated={isAuthenticated}
            permissions={permissions}
            requiredPermissions={requiredPermissions}
            routePattern={path}
            onForbidden={handleForbidden}
          >
            {page}
          </PermissionRoute>
        }
      />
    );
  }, [handleForbidden, handleLogout, isAuthenticated, permissions]);

  if (loading) return <PageLoader />;

  return (
    <>
      <CssBaseline />

      <Suspense fallback={<PageLoader />}>
        {isAuthenticated && tenantSelected ? (
          <Routes>
            <Route
              path="/login"
              element={
                <AuthenticatedLoginRedirect permissions={permissions} />
              }
            />

            <Route
              path="/pos"
              element={
                <PermissionRoute
                  isAuthenticated={isAuthenticated}
                  permissions={permissions}
                  requiredPermissions={['pos:terminal:ver']}
                  routePattern="/pos"
                  onForbidden={handleForbidden}
                >
                  <ExternalRedirect to={POS_EXTERNAL_URL} />
                </PermissionRoute>
              }
            />

            <Route
              path="/*"
              element={
                <Layout onLogout={handleLogout}>
                  <Routes>
                    <Route
                      path="/"
                      element={<RootEntry permissions={permissions} />}
                    />
                    <Route path={ACCESS_DENIED_PATH} element={<AccessDeniedPage />} />
                    {APP_ROUTE_DEFINITIONS.map(renderApplicationRoute)}
                    <Route path="*" element={<UnknownRouteRedirect />} />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        ) : (
          <Routes>
            <Route path="/login" element={<LoginForm onLogin={handleLogin} />} />
            <Route path="*" element={<LoginRedirect />} />
          </Routes>
        )}
      </Suspense>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar((current) => ({ ...current, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar((current) => ({ ...current, open: false }))}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;